var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-wallpaper-item"},[_c('div',{staticClass:"pic"},[_c('img',{attrs:{"src":_vm.data.preview_jpg,"alt":""}})]),_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(_vm.data.wname))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }